import { Box, Divider, Stack } from '@mui/material';
import type { ReactNode } from 'react';
import { FLOW_CONTROL_MEDIA_PLAY_SLOT_WIDTH_PX } from '../flow-detail.types';

const playSlotSx = {
  position: 'relative',
  width: FLOW_CONTROL_MEDIA_PLAY_SLOT_WIDTH_PX,
  minWidth: FLOW_CONTROL_MEDIA_PLAY_SLOT_WIDTH_PX,
  maxWidth: FLOW_CONTROL_MEDIA_PLAY_SLOT_WIDTH_PX,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  height: '100%',
  alignSelf: 'stretch',
} as const;

/**
 * Segment play column only. Empty media-rail slots are not reserved so the title
 * can use the leftover width; play stays right-aligned with media rows.
 */
export function FlowControlPlayColumnRail({
  children,
  onSpacerClick,
}: {
  children: ReactNode;
  /** Kept for callers; the card click already expands the segment. */
  onSpacerClick?: () => void;
}) {
  void onSpacerClick;
  return (
    <Stack
      direction="row"
      alignItems="stretch"
      justifyContent="flex-end"
      sx={{
        width: FLOW_CONTROL_MEDIA_PLAY_SLOT_WIDTH_PX,
        minWidth: FLOW_CONTROL_MEDIA_PLAY_SLOT_WIDTH_PX,
        maxWidth: FLOW_CONTROL_MEDIA_PLAY_SLOT_WIDTH_PX,
        flexShrink: 0,
        height: '100%',
        alignSelf: 'stretch',
      }}
    >
      <Box sx={playSlotSx}>
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            position: 'absolute',
            left: 0,
            top: 4,
            bottom: 4,
            height: 'auto',
          }}
        />
        {children}
      </Box>
    </Stack>
  );
}
